import { ExtractPropTypes, PropType } from "vue";

export const UiTimePickerPropsOption = {
    classExtraName: { type: String, default: "" },
    placeholder: { type: Object as PropType<{ start: string; end: string }>, default: { start: "开始时间", end: "结束时间" } },
    modelValue: { type: Object as PropType<{ start: string; end: string }>, required: true },
    separator: { type: String, default: "至" }, //* 中间分割
    zIndex: { type: Number, default: 66 },
    width: { type: [String, Number] as PropType<number | string>, default: 350 },
    mode: { type: String as PropType<"seconds" | "minutes">, default: "seconds" },
    name: { type: String, default: "" },
};

export type UiTimePickerProps = ExtractPropTypes<typeof UiTimePickerPropsOption>;

export const UiTimePickerEmits = {
    "update:modelValue": (_ev: { start: string; end: string }) => true,
    "before-enter": () => true,
    "before-leave": () => true,
    "after-enter": () => true,
    "after-leave": () => true,
    "change": (_ev: { start: string; end: string }) => true,
};
